"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ThemeToggle {
    constructor(electronWrapper) {
        this.electronWrapper = electronWrapper;
        this.restrict = "E";
        this.template = `
    <div class="theme-toggle-row">
      <span>{{'THEME_TOGGLE' | translate }}</span>
      <label class="switch">
        <input class="modal-checkbox" type="checkbox" ng-click="toggleTheme()" ng-checked="isDark">
        <span class="slider round"></span>
      </label>
    </div>
  `;
        this.link = (scope, element, attrs) => {
            const customScope = scope;
            customScope.isDark = localStorage.getItem("theme") === "dark";
            if (customScope.isDark) {
                document.documentElement.classList.add("dark");
            }
            this.electronWrapper.setDarkTheme(customScope.isDark);
            customScope.toggleTheme = () => {
                const isDark = document.documentElement.classList.toggle("dark");
                localStorage.setItem("theme", isDark ? "dark" : "light");
                customScope.isDark = isDark;
                this.electronWrapper.setDarkTheme(isDark);
            };
        };
    }
}
exports.default = ThemeToggle;
ThemeToggle.$inject = ["electronWrapper"];
